export default __webpack_public_path__ + "static/media/gallery21.423cbab5.webp";